/**
 * Sesión de usuario
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
import KeyValuePair from '@/modules/core/support/KeyValuePair';
import moment from 'moment';

export default class Session {
    public id = 0
    public token = ''
    public open = false
    public data: KeyValuePair = {}
    public createdAt = new Date()
    public lifetime = 0

    public static deserialize (data: KeyValuePair) {
        return Object.assign(new this(), {
            id: data.id,
            token: data.token,
            open: data.open,
            data: data.data || {},
            createdAt: moment(data.created_at, 'DD/MM/YYYY HH:mm:ss'),
            lifetime: data.lifetime || 0,
        })
    }
}
